export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map